import React, { useState } from "react";

const CopyableText = ({ value, displayValue, className }) => {
  const [copied, setCopied] = useState(false);

  if (value === null || value === undefined) return null;

  const textToCopy = String(value);
  const renderedText = displayValue !== undefined ? displayValue : textToCopy;

  const handleCopy = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(textToCopy);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = textToCopy;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch (error) {
      setCopied(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleCopy();
    }
  };

  return (
    <span
      className={`copyable ${className || ""}`}
      role="button"
      tabIndex={0}
      onClick={handleCopy}
      onKeyDown={handleKeyDown}
      title="Copy"
      aria-label="Copy"
    >
      <span>{renderedText}</span>
      <i
        className={`fa ${copied ? "fa-check" : "fa-copy"} copyable__icon`}
        aria-hidden="true"
      />
    </span>
  );
};

export default CopyableText;



// WEBPACK FOOTER //
// ./src/components/common/copyableText.jsx